<template>
  <div
    class="bbe-select-users__wrapper"
    @click.stop
    :style="positionStyle"
    @mouseleave="onClose"
  >
    <VuePerfectScrollbar
      v-click-outside="onClose"
      class="bbe-select-users"
      tabindex="0"
      :settings="scrollSettings"
    >
      <div class="bbe-select-users__margin bbe-select-users__margin_top"/>
      <div
        class="bbe-select-users-user"
        @click.stop="setUser(user)"
        v-for="user in usersList"
        :key="user._id"
      >
        <div
          v-if="user.image"
          class="bbe-select-users-user__image"
          :class="[activeUserId === user._id && 'bbe-select-users-user__image_active']"
        >
          <img :src="user.image"/>
        </div>
        <i
          v-else
          class="bbe-icon-user bbe-select-users-user__image"
        />
        <div>
          <div class="bbe-select-users-user__username">
            {{user.username}}
          </div>
          <div class="bbe-select-users-user__email">
            {{user.email}}
          </div>
        </div>
      </div>
      <div class="bbe-select-users__margin bbe-select-users__margin_bottom"/>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {get} from 'lodash'

export default {
  name: 'BBESelectUsers',
  props: {
    usersList: {
      type: Array,
      default: () => ([])
    },
    positionStyle: {
      type: Object,
      default: () => ({})
    },
    activeUserId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    scrollSettings: {
      wheelPropagation: false,
      minScrollbarLength: 25
    }
  }),
  components: {
    VuePerfectScrollbar
  },
  methods: {
    getUserImage (user) {
      return get(user, 'image.path', '')
    },
    setUser (user) {
      this.$emit('setUser', user)
    },
    onClose () {
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

  .bbe-select-users {
    overflow: hidden;
    max-height: 194px;

    &__wrapper {
      position: absolute;
      top: 34px;
      left: 1px;
      width: auto;
      min-width: 245px;
      background-color: $color-white;
      box-shadow: 0 0 12px rgba($color-black, 0.12);
      border-radius: 5px;
      z-index: 10;
    }

    &__margin {
      position: sticky;
      background-color: $color-white;
      height: 9px;
      width: 100%;
      z-index: 2;

      &_top {
        top: 0;
      }

      &_bottom {
        bottom: 0
      }
    }

    &-user {
      display: grid;
      grid-template-columns: 36px auto;
      grid-gap: 12px 12px;
      align-items: center;
      transition: 0.3s;
      cursor: pointer;
      padding: 6px 12px 6px 12px;

      &:hover {
        background: $color-bright-gray;
      }

      &__image {
        width: 36px;
        height: 36px;
        color: $color-accent;
        object-fit: cover;
        font-size: 36px;
        border-radius: 50%;
        overflow: hidden;

        img {
          height: 100%;
          width: 100%;
        }

        &:before {
          margin: 0;
        }

        &_active {
          border: 2px solid $color-denim;
        }
      }

      &__username {
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        text-transform: capitalize;
      }

      &__email {
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        color: $color-silver-chalice;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBESelectUsers/BBESelectUsers.vue